// ----------------------------------------------------------------------------
// Component: Hero Banner
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import "snippets/background-media/background-media";
import "snippets/sticky-cta-button/sticky-cta-button";

// Styles
import "./_hero-banner.scss";

// -------------------------------------
// Hooks
// -------------------------------------

function removeAutoplayOnMobileAndTablet() {
    if ($(window).innerWidth() >= 1025) return;

    $(".video-block__video").removeAttr("autoplay");
}

function getProductIds(string) {
    var urlToSplit = new URL(string);
    var productsSplit = urlToSplit.pathname.split("/cart/");
    var productsStr = productsSplit[1];
    var productsAndQuantity = productsStr.split(",");
    var justProducts = [];

    productsAndQuantity.forEach((product) => {
        justProducts.push(product.replace(":1", ""));
    });

    return justProducts;
}

$(function () {
    removeAutoplayOnMobileAndTablet();

    var heroCtas = document.querySelectorAll(".hero-banner__button");
    var uniqueHeroUrls = {};

    for (var i = 0; i < heroCtas.length; i++) {
        var currentHeroCta = heroCtas[i];
        if (
            !uniqueHeroUrls[currentHeroCta.href] &&
            currentHeroCta.href.includes("/cart/")
        ) {
            uniqueHeroUrls[currentHeroCta.href] = true;
            var productIds = getProductIds(currentHeroCta.href);
            productIds.forEach((productId) => {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                // TODO: Refactor to use standard GA4 view_item event and include more product info (price, variant, quantity, etc.)
                window.dataLayer.push({
                    event: "view_item_dsc",
                    ecommerce: {
                        items: [
                            {
                                item_id: productId,
                            },
                        ],
                    },
                });
            });
        }
    }
});
